import { registerPlugin } from "@capacitor/core";

export interface CustomerDisplayPlugin {
  getDisplays(): Promise<{ displays: any[] }>;
  open(options: { path: string }): Promise<any>;
  close(): Promise<any>;
  send(options: { message: any }): Promise<any>;
}

export const CustomerDisplay = registerPlugin<CustomerDisplayPlugin>("CustomerDisplay");
